// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDllYLohBndhln3w-QzsK-kP9I9nIglJow",
  authDomain: "theperspectivehq.firebaseapp.com",
  projectId: "theperspectivehq",
  storageBucket: "theperspectivehq.firebasestorage.app",
  messagingSenderId: "94588133408",
  appId: "1:94588133408:web:25e30460be4db4166e5c45",
  measurementId: "G-MB0HQ4WLL9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

// Export app, db, and analytics
export { app, db, analytics };
